<template>
  <div class="v-view swiper-view a-fadeIn model2" :style="{ height: span * 33.33 + '%' }">
    <div class="v-title">
      <span class="v-model-title">{{ title }}</span>
    </div>

    <!-- <swiper v-if="swiperList.length > 0" ref="orderSwiper" class="sv-swiper" :options="swiperOption">
      <swiper-slide class="sv-swiper-slide" v-for="(item, index) in swiperList" :key="item.id" :data-index="index"> -->
    <div v-if="swiperList.length > 0" class="sv-swiper scroller">
      <div class="sv-swiper-slide" v-for="(item, index) in swiperList" :key="index" @click="swiper(item)">
        <div class="sv-swiper-slide__avatar">
          <img src="../assets/images/img_alarm.png" class="animated" alt="#" />
          <div :class="{ 'a-rolling': item.rolling }">{{ item.DeviceType | getName }}</div>
        </div>
        <div class="sv-swiper-slide__info">
          <div class="sv-swiper-slide__wrap">
            <div class="sv-swiper-slide__time">
              <img src="../assets/images/icon_time.png" alt="#" />
              <span>{{ item.AlertTime }}</span>
            </div>
            <div class="sv-swiper-slide__address">
              <img src="../assets/images/icon_address.png" alt="#" />
              <span>{{ item.Position || "--" }}</span>
            </div>
          </div>
          <div class="sv-swiper-slide__wrap sv-swiper-slide__desc">
            <img src="../assets/images/icon_content.png" alt="#" />
            <span>{{ item.AlertMsg }}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- </swiper-slide>
    </swiper> -->
    <div v-else class="sv-nodata">暂无数据!</div>
    <el-dialog title="报警信息详情" :visible.sync="alarmDialog" class="alarmDelog" :modal="false" width="30%" center>
      <div class="alarm">长者姓名：{{ alarmData.ElderName || "--" }}</div>
      <div class="alarm">长者年龄：{{ alarmData.ElderAge || "--" }}</div>
      <div class="alarm">长者性别：{{ alarmData.ElderSex || "--" || "--" }}</div>
      <div class="alarm">联系方式：{{ alarmData.ElderMobilePhone || "--" }}</div>
      <div class="alarm">亲情号码：{{ alarmData.SmartCareDeviceBFamilyNumber || "--" }}</div>
      <div class="alarm">报警时间：{{ alarmData.AlertTime }}</div>
      <div class="alarm">居住地址：{{ alarmData.Position || "--" }}</div>
      <div class="alarm alarmInfo">报警信息：{{ alarmData.AlertMsg || "--" }}</div>
      <div class="alarm">报警状态：
        <el-radio v-model="radio" label="1">已处理</el-radio>
        <el-radio v-model="radio" label="2">误报</el-radio>
        <el-radio v-model="radio" label="3">其他</el-radio>
      </div>
      <div class="alarm">处理意见：<el-input type="textarea" class="mt10" :rows="2" placeholder="请输入处理意见" v-model="textarea">
        </el-input></div>
      <div class="cuhli">
        <el-button type="primary" @click="alermT0Do(alarmData)">处理报警</el-button>
      </div>
    </el-dialog>
  </div>
</template>
  
<script>
import { mapGetters } from 'vuex'
import { animateWithDelay } from '@/utils'

export default {
  name: 'AlarmInformation',
  filters: {
    // textFmt(text) {
    //   if (!text) return
    //   const index1 = text.indexOf('市')
    //   const index2 = text.indexOf('自治区')
    //   if (index1 !== -1) {
    //     return text.substr(index1 + 1)
    //   } else if (index2 !== -1) {
    //     return text.substr(index2 + 3)
    //   } else {
    //     return text
    //   }
    // },
    timeFmt(text) {
      if (!text) return
      return text.split('T')[0] + " " + text.split('T')[1]
    },
    getName(text) {
      if (!text) return '智能报警'
      return text
    },
  },
  computed: {
    ...mapGetters(['cid', 'userId']),
  },
  props: {
    span: {
      type: Number,
      default: 1,
    },
    title: {
      type: String,
      default: '智能设备报警信息',
    },
  },
  watch: {
    swiperData(newData, oldData) {
      // const newItem = newData.length && newData[0]
      // const oldItem = oldData.length && oldData[0]
      // if (!oldItem || newItem.AlertTime !== oldItem.AlertTime) {
      if (newData !== oldData) {
        this.swiperList = newData;
        this.$nextTick(() => {
          if (!this.orderSwiper) {
            this.orderSwiper = this.$refs.orderSwiper && this.$refs.orderSwiper.swiper
          }
          this.orderSwiper && this.orderSwiper.slideToLoop(0, 0, false)
        })
      }
    },
  },
  data() {
    const that = this
    return {
      dialogVisible: false,
      dataInterval: null,
      orderData: {},
      orderSwiper: null,
      photoSwiper: null,
      swiperData: [],
      swiperList: [],
      swiperOption: {
        direction: 'vertical',
        grabCursor: true,
        slidesPerView: 4,
        speed: 1000,
        loop: true,
        observer: true,
        observeParents: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        on: {
          click(e) {
            const index = +this.clickedSlide.dataset.index
            // const orderID = vm.swiperList[index].id
            // vm.getServiceOrderData(orderID)
            that.alarmData = that.swiperData[index]
            that.alarmDialog = true;
          },
          autoplay() {
            const slider = this.slides[this.activeIndex + 3]
            const icon = slider.querySelector('.animated')
            animateWithDelay(icon, 'zoomIn', 1500)
          },
        },
      },
      orderOption: {
        grabCursor: true,
        speed: 1000,
        loop: false,
        observer: true,
        observeParents: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
      },
      alarmDialog: false,
      alarmData: {
        AlertMsg: "--",
        AlertTime: "--",
        DeviceType: "--",
        ElderAge: '--',
        ElderMobilePhone: "--",
        ElderName: "--",
        ElderSex: "--",
        HeadImgPath: "--",
        Lat: "--",
        Long: "--",
        Position: "--",
        SmartCareDeviceBFamilyNumber: "--",
      },
      radio: '1',
      textarea: '',
    }
  },
  created() {
    this.getServiceDynamicData(this.cid)
  },
  mounted() {
    this.dataInterval = setInterval(() => {
      this.getServiceDynamicData(this.cid)
    }, this.$interval)
  },
  beforeDestroy() {
    if (this.orderSwiper) {
      this.orderSwiper.destroy()
      this.orderSwiper = null
    }
    if (this.photoSwiper) {
      this.photoSwiper.destroy()
      this.photoSwiper = null
    }
  },
  methods: {
    swiper(data) {
      this.alarmData = data
      this.alarmDialog = true;
    },
    alermT0Do(data) {
      let alertId = data.ID;
      let userId = this.userId;
      let stateID = this.radio;
      let remark = this.textarea;
      let ElderName = data.ElderName;
      if (remark == '') {
        return this.$message({
          type:'error',
          message:'请填写处理意见！'
        })
      }
      this.$api
        .dealSmartAlertInfo(alertId, userId, stateID, remark)
        .then((data) => {
          this.alarmDialog = false
          this.radio = '1'
          this.textarea = ''
          this.$message({
            message: ElderName + '报警已处理！',
            type: 'success'
          })
          this.getServiceDynamicData(this.cid)
        })
        .catch((error) => {
          console.error(error)
        })
    },
    onDialogOpened() {
      if (!this.photoSwiper) this.photoSwiper = this.$refs.photoSwiper && this.$refs.photoSwiper.swiper
      if (this.photoSwiper) {
        this.photoSwiper.slideTo(0, 0, false)
        if (this.orderData.photos.length === 1) {
          this.photoSwiper.autoplay.stop()
        } else {
          this.photoSwiper.autoplay.start()
        }
      }
    },
    getServiceDynamicData(cid) {
      this.$api
        .getSmartAlertinfo(cid, 100)
        .then((data) => {
          if (!data || !data.length) return
          this.swiperData = data
        })
        .catch((error) => {
          console.error(error)
        })
    },
  },
}
</script>
  
<style lang="scss" scoped>
.sv-swiper {
  width: 100%;
  height: 100%;
  overflow: hidden;
  overflow-y: auto;
}

.mt10 {
  margin-top: 10px;
}

.alarmInfo {
  background-color: rgba(254, 80, 3, 0.7);
  padding: 5px 0px;
}

.alarm {
  font-size: 16px;
  color: #fff;
  line-height: 1.25;
  margin-bottom: 15px;
}

.sv-swiper-slide__info {
  display: block;
}

.swiper-view {
  .sv-nodata {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
  }

  .sv-swiper {
    width: 100%;
    height: 100%;
  }

  .sv-swiper-slide {
    display: flex;
    align-items: center;
    padding: 5px 20px;
    padding-right: 10px;

    +.sv-swiper-slide::before {
      content: '';
      position: absolute;
      top: -0.5px;
      width: 100%;
      height: 1px;
      background: url('../assets/images/bg_line.png') no-repeat center center/60% 100%;
    }

    &__avatar {
      display: inline-flex;
      flex-direction: column;
      align-items: center;
      flex: none;
      width: 65px;
      overflow: hidden;

      >img {
        width: 36px;
        height: 36px;
        border-radius: 50%;
        border: 1px solid #0077fc;
      }

      >div {
        z-index: -1; // 解决IE隐藏失效问题
        width: auto;
        font-size: 12px;
        text-align: center;
        white-space: nowrap;
      }
    }

    &__info {
      flex: none;
      width: calc(100% - 60px);
      margin-left: 10px;
      //   background-color: red;
    }

    &__wrap {
      //   display: flex;
      //   align-items: center;
      width: 100%;
      font-size: 12px;
      color: #96d0fc;

      +.sv-swiper-slide__wrap {
        margin-top: 5px;
      }

      img {
        width: 15px;
        height: auto;
        margin-right: 5px;
      }

      span {
        @include text-ellipsis-single;
      }
    }

    &__time {
      width: 150px;
      display: inline-flex;
      align-items: center;

      span {
        width: 155px;
      }
    }

    &__address {
      width: 150px;
      display: inline-flex;
      align-items: center;

      span {
        width: 200px;
      }
    }

    &__desc {
      font-size: 14px;
      color: #fff;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;

      span {
        display: block;
        // width: 280px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
}
</style>
  